<template>
<!-- ==========促销补差策略组件 ==============-->
<div>
  <div class="salesPromotion">
    <el-form :model="FZCX2022" class="toolbar" ref="FZCX2022" label-width="100px">
      <div class="mod-block">
        <el-checkbox v-model="strategyOne" @change="handleCheckbox">促销类型补差策略</el-checkbox>
        <div class="mask" v-if="!strategyOne"></div>
        <el-row>
          <el-col :span="6">
            <span class="red classify">*</span>折扣
            <el-tooltip placement="top" content="包括但不限于品类、品牌、单品折扣、积分折扣、会员折扣等">
              <el-button icon="el-icon-question" circle size="mini"></el-button>
            </el-tooltip>
          </el-col>
          <el-col :span="18">
            <el-radio-group v-model="xhGroup" class="input-item" :disabled="isLook">
              <el-radio :label="1">售价损失补差</el-radio>
              <div class="right-input">
                <el-form-item label="≤5折" prop="XY5Z" :rules="[{validator: validatorNum, trigger: 'blur', strategy: strategyOne}]">
                  <el-input-number placeholder="请填写供应商承担比例" v-model="FZCX2022.XY5Z" :disabled="isLook || zkGroup != '1'" :controls="false" :min="0" :max="100" :precision="2"></el-input-number>
                  <span class="suffixRight">%</span>
                </el-form-item>
                <el-form-item label="5折＜X≤6折" prop="D5X6Z" :rules="[{validator: validatorNum, trigger: 'blur', strategy: strategyOne}]">
                  <el-input-number placeholder="请填写供应商承担比例" v-model="FZCX2022.D5X6Z" :disabled="isLook || zkGroup != '1'" :controls="false" :min="0" :max="100" :precision="2"></el-input-number>
                  <span class="suffixRight">%</span>
                </el-form-item>
                <el-form-item label="6折＜X≤7折" prop="D6X7Z" :rules="[{validator: validatorNum, trigger: 'blur', strategy: strategyOne}]">
                  <el-input-number placeholder="请填写供应商承担比例" v-model="FZCX2022.D6X7Z" :disabled="isLook || zkGroup != '1'" :controls="false" :min="0" :max="100" :precision="2"></el-input-number>
                  <span class="suffixRight">%</span>
                </el-form-item>
                <el-form-item label="＞7折" prop="DY7Z" :rules="[{validator: validatorNum, trigger: 'blur', strategy: strategyOne}]">
                  <el-input-number placeholder="请填写供应商承担比例" v-model="FZCX2022.DY7Z" :disabled="isLook || zkGroup != '1'" :controls="false" :min="0" :max="100" :precision="2"></el-input-number>
                  <span class="suffixRight">%</span>
                </el-form-item>
              </div>
            </el-radio-group>
          </el-col>  
        </el-row>
        <el-row>
          <el-col :span="6">
            <span class="red classify">*</span>买赠
            <el-tooltip placement="top" content="包括免单">
              <el-button icon="el-icon-question" circle size="mini"></el-button>
            </el-tooltip>
          </el-col>
          <el-col :span="18">
            <el-radio-group v-model="xhGroup" class="input-item" :disabled="isLook">
              <el-radio :label="1">售价损失补差</el-radio>
              <div class="right-input">
                <el-form-item label-width="0" prop="MZSJSSBC" :rules="[{validator: validatorNum, trigger: 'blur', strategy: strategyOne}]">
                  <el-input-number v-model="FZCX2022.MZSJSSBC" :disabled="isLook" :controls="false" :min="0" :max="100" :precision="2"></el-input-number>
                  <span class="suffixRight">%</span>
                </el-form-item>
              </div>
            </el-radio-group>
          </el-col>        
        </el-row>
        <el-row>
          <el-col :span="6">
            <span class="red classify">*</span>梯次
            <el-tooltip placement="top" content="梯次促销">
              <el-button icon="el-icon-question" circle size="mini"></el-button>
            </el-tooltip>
          </el-col>
          <el-col :span="18">
            <el-radio-group v-model="xhGroup" class="input-item" :disabled="isLook">
              <el-radio :label="1">售价损失补差</el-radio>
              <div class="right-input">
                <el-form-item label-width="0" prop="TCSJSSBC" :rules="[{validator: validatorNum, trigger: 'blur', strategy: strategyOne}]">
                  <el-input-number v-model="FZCX2022.TCSJSSBC" :disabled="isLook" :controls="false" :min="0" :max="100" :precision="2"></el-input-number>
                  <span class="suffixRight">%</span>
                </el-form-item>
              </div>
            </el-radio-group>
          </el-col>        
        </el-row>
        <el-row>
          <el-col :span="6">
            <span class="red classify">*</span>送券
            <el-tooltip placement="top" content="售价损失等于券面金额">
              <el-button icon="el-icon-question" circle size="mini"></el-button>
            </el-tooltip>
          </el-col>
          <el-col :span="18">
            <el-radio-group v-model="xhGroup" class="input-item" :disabled="isLook">
              <el-radio :label="1">售价损失补差</el-radio>
              <div class="right-input">
                <el-form-item label-width="0" prop="SQSJSSBC" :rules="[{validator: validatorNum, trigger: 'blur', strategy: strategyOne}]">
                  <el-input-number v-model="FZCX2022.SQSJSSBC" :disabled="isLook" :controls="false" :min="0" :max="100" :precision="2"></el-input-number>
                  <span class="suffixRight">%</span>
                </el-form-item>
              </div>
            </el-radio-group>
          </el-col>        
        </el-row>
        <el-row>
          <el-col :span="6">
            <span class="red classify">*</span>出清
            <el-tooltip placement="top" content="只针对不可退商品，可退商品原则上不出清，否则100%承担补差">
              <el-button icon="el-icon-question" circle size="mini"></el-button>
            </el-tooltip>
          </el-col>
          <el-col :span="18">
            <el-radio-group v-model="xhGroup" class="input-item" :disabled="isLook">
              <el-radio :label="1">售价损失补差</el-radio>
              <div class="right-input">
                <el-form-item label-width="0" prop="CQSJSSBC" :rules="[{validator: validatorNum, trigger: 'blur', strategy: strategyOne}]">
                  <el-input-number v-model="FZCX2022.CQSJSSBC" :disabled="isLook" :controls="false" :min="0" :max="100" :precision="2"></el-input-number>
                  <span class="suffixRight">%</span>
                </el-form-item>
              </div>
            </el-radio-group>
          </el-col>        
        </el-row>
        <el-row>
          <el-col :span="6">
            <span class="red classify">*</span>其他类型
            <el-tooltip placement="top" content="包括但不限于满立减、组合促销等">
              <el-button icon="el-icon-question" circle size="mini"></el-button>
            </el-tooltip>
          </el-col>
          <el-col :span="18">
            <el-radio-group v-model="xhGroup" class="input-item" :disabled="isLook">
              <el-radio :label="1">售价损失补差</el-radio>
              <div class="right-input">
                <el-form-item label-width="0" prop="QTSJSSBC" :rules="[{validator: validatorNum, trigger: 'blur', strategy: strategyOne}]">
                  <el-input-number v-model="FZCX2022.QTSJSSBC" :disabled="isLook" :controls="false" :min="0" :max="100" :precision="2"></el-input-number>
                  <span class="suffixRight">%</span>
                </el-form-item>
              </div>
            </el-radio-group>
          </el-col>        
        </el-row>
        <el-row>
          <el-col :span="6">固定价格促销
            <el-tooltip placement="top" content="包括但不限于一般固定价格、DM固定价格、小时促销、会员固定价格、秒杀、预售、拼团、砍价等">
              <el-button icon="el-icon-question" circle size="mini"></el-button>
            </el-tooltip>
          </el-col>
          <el-col :span="18">
            <el-form-item label-width="0" prop="sendersWay">
              <el-checkbox-group v-model="FZCX2022.sendersWay">
                <el-checkbox label="1">库存补差</el-checkbox>
                <el-checkbox label="2">特进价入库</el-checkbox>
                <el-checkbox label="3">销售补差</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </el-col>        
        </el-row>
      </div>
      <div class="mod-block">
        <el-checkbox v-model="strategyTwo" @change="handleCheckbox">整体促销补差策略</el-checkbox>
        <div class="mask" v-if="!strategyTwo"></div>
        <el-row>
          <el-col :span="6">
            <span class="red classify">*</span>促销补差
            <el-tooltip content="促销包括但不限于特价、折扣、满立减等" placement="top" class="tooltipBtn">
              <el-button icon="el-icon-question" circle size="mini"></el-button>
            </el-tooltip>
          </el-col>
          <el-col :span="18">
            <el-radio-group v-model="xhGroup" class="input-item" :disabled="isLook">
              <el-radio :label="1">目标毛利率补差</el-radio>
              <div class="right-input">
                <el-form-item label="＞7折" prop="NDCXMBMLLBCDY7Z" :rules="[{validator: validatorNum, trigger: 'blur', strategy: strategyTwo}]">
                  <el-input-number v-model="FZCX2022.NDCXMBMLLBCDY7Z" :disabled="isLook || zkGroup != '1'" :controls="false" :min="0" :max="100" :precision="2"></el-input-number>
                  <span class="suffixRight">%</span>
                </el-form-item>
                <el-form-item label="6折＜X≤7折" prop="NDCXMBMLLBCD6X7Z" :rules="[{validator: validatorNum, trigger: 'blur', strategy: strategyTwo}]">
                  <el-input-number v-model="FZCX2022.NDCXMBMLLBCD6X7Z" :disabled="isLook || zkGroup != '1'" :controls="false" :min="0" :max="100" :precision="2"></el-input-number>
                  <span class="suffixRight">%</span>
                </el-form-item>
                <el-form-item label="5折＜X≤6折" prop="NDCXMBMLLBCD5X6Z" :rules="[{validator: validatorNum, trigger: 'blur', strategy: strategyTwo}]">
                  <el-input-number v-model="FZCX2022.NDCXMBMLLBCD5X6Z" :disabled="isLook || zkGroup != '1'" :controls="false" :min="0" :max="100" :precision="2"></el-input-number>
                  <span class="suffixRight">%</span>
                </el-form-item>
                <el-form-item label="≤5折" prop="NDCXMBMLLBCXY5Z" :rules="[{validator: validatorNum, trigger: 'blur', strategy: strategyTwo}]">
                  <el-input-number v-model="FZCX2022.NDCXMBMLLBCXY5Z" :disabled="isLook || zkGroup != '1'" :controls="false" :min="0" :max="100" :precision="2"></el-input-number>
                  <span class="suffixRight">%</span>
                </el-form-item>
              </div>
            </el-radio-group>
          </el-col>  
        </el-row>
      </div>
      <div class="mod-block">
        <el-checkbox v-model="strategyThree" disabled>其他</el-checkbox>
        <el-row>
          <el-col :span="6"><span class="red classify">*</span>省心价商品
          </el-col>
          <el-col :span="18">
            <div class="input-item">
              <!-- 正数 -->
              <el-form-item label-width="0" prop="SXJSP" class="right-input" style="max-width: 361px;" :rules="[{validator: validatorNum, trigger: 'blur', strategy: strategyThree}]">
                <el-input-number v-model="FZCX2022.SXJSP" :disabled="isLook" :controls="false" :min="0" :max="100" :precision="0"></el-input-number>
                <span class="suffixRight">支</span>
              </el-form-item>
            </div>
          </el-col>        
        </el-row>
        <el-row>
          <el-col :span="6"><span class="red classify">*</span>新店及新品首单进货折扣
          </el-col>
          <el-col :span="18">
            <div class="input-item">
              <!-- 正数 -->
              <el-form-item label-width="0" prop="XDJXPSDJHZK" class="right-input" style="max-width: 361px;" :rules="[{validator: validatorNum, trigger: 'blur', strategy: strategyThree}]">
                <el-input-number v-model="FZCX2022.XDJXPSDJHZK" :disabled="isLook" :controls="false" :min="0" :max="100" :precision="2"></el-input-number>
                <span class="suffixRight">%</span>
              </el-form-item>
            </div>
          </el-col>        
        </el-row>
        <el-row>
          <el-col :span="6">
            <span class="red classify">*</span>淘汰商品洗货
          </el-col>
          <el-col :span="18">
            <el-radio-group v-model="xhGroup" class="input-item" :disabled="isLook">
              <el-radio :label="1">目标毛利率补差</el-radio>
              <div class="right-input">
                <el-form-item label="第1月：7折" prop="TTSPXHMBMLLBC7Z" :rules="[{validator: validatorNum, trigger: 'blur', strategy: strategyThree}]">
                  <el-input-number v-model="FZCX2022.TTSPXHMBMLLBC7Z" :disabled="isLook || zkGroup != '1'" :controls="false" :min="0" :max="100" :precision="2"></el-input-number>
                  <span class="suffixRight">%</span>
                </el-form-item>
                <el-form-item label="第2月：5折" prop="TTSPXHMBMLLBC5Z" :rules="[{validator: validatorNum, trigger: 'blur', strategy: strategyThree}]">
                  <el-input-number v-model="FZCX2022.TTSPXHMBMLLBC5Z" :disabled="isLook || zkGroup != '1'" :controls="false" :min="0" :max="100" :precision="2"></el-input-number>
                  <span class="suffixRight">%</span>
                </el-form-item>
                <el-form-item label="第3月：3折" prop="TTSPXHMBMLLBC3Z" :rules="[{validator: validatorNum, trigger: 'blur', strategy: strategyThree}]">
                  <el-input-number v-model="FZCX2022.TTSPXHMBMLLBC3Z" :disabled="isLook || zkGroup != '1'" :controls="false" :min="0" :max="100" :precision="2"></el-input-number>
                  <span class="suffixRight">%</span>
                </el-form-item>
                <el-form-item label="第4月：1折" prop="TTSPXHMBMLLBC1Z" :rules="[{validator: validatorNum, trigger: 'blur', strategy: strategyThree}]">
                  <el-input-number v-model="FZCX2022.TTSPXHMBMLLBC1Z" :disabled="isLook || zkGroup != '1'" :controls="false" :min="0" :max="100" :precision="2"></el-input-number>
                  <span class="suffixRight">%</span>
                </el-form-item>
              </div>
            </el-radio-group>
          </el-col>        
        </el-row>
      </div>
    </el-form>
  </div>
</div>
</template>
<script>
export default {
  props:{
    contractLocalid:{
      type:Number,
      required:true
    },
    GETFZCX:{
      type:Object,
      required:true
    }
  },
  data(){
    return {
      FZCX2022:{
        NDCXMBMLLBCDY7Z: undefined,
        NDCXMBMLLBCD6X7Z: undefined,
        NDCXMBMLLBCD5X6Z: undefined,
        NDCXMBMLLBCXY5Z: undefined,
        SXJSP: undefined,
        TTSPXHMBMLLBC7Z: undefined,
        TTSPXHMBMLLBC5Z: undefined,
        TTSPXHMBMLLBC3Z: undefined,
        TTSPXHMBMLLBC1Z: undefined,
        sendersWay: []
      },
      zkGroup: 1,   //折扣单选组
      xhGroup: 1, // 洗货折扣组
      source:'',
      strategyOne: false, // 促销类型补差策略
      strategyTwo: false,  // 整体促销补差策略
      strategyThree: true // 其他补差策略
    }
  },
  methods: {   
    validatorNum (rule, value, callback) {
      if (rule.strategy && !value) {
        return callback(new Error('请输入'))
      }
      if (value < 0 || value > 100) {
        return callback(new Error('100＞X≥0的正数数值，保留2位小数'))
      }
      callback();
    },  
    validateOther(flag){
      if (!this.strategyOne && !this.strategyTwo) {
        this.msgCallback('促销类型补差策略、整体促销补差策略必选其一填入，可两项都填');
        return
      }
      this.$refs["FZCX2022"].validate(valid => {
				if(valid) {
          //如果校验通过传true给父组件用来判断
          this.$emit("getUpdateFlag",true);
        }
      })
    },
    //结果返回成功失败类型的接口回调
    msgCallback(info){
      this.$message.error(info);
      return false
    },
    handleCheckbox (val) {
      this.$nextTick(() => {
        if (!this.strategyOne) {
          this.$refs["FZCX2022"].validateField(['XY5Z','D5X6Z','D6X7Z','DY7Z','ZKMBMLLBC','MZSJSSBC','TCSJSSBC','SQSJSSBC','CQSJSSBC','QTSJSSBC'])
          this.FZCX2022.XY5Z = undefined
          this.FZCX2022.D5X6Z = undefined
          this.FZCX2022.D6X7Z = undefined
          this.FZCX2022.DY7Z = undefined
          this.FZCX2022.ZKMBMLLBC = undefined
          this.FZCX2022.MZSJSSBC = undefined
          this.FZCX2022.TCSJSSBC = undefined
          this.FZCX2022.SQSJSSBC = undefined
          this.FZCX2022.CQSJSSBC = undefined
          this.FZCX2022.QTSJSSBC = undefined
          this.FZCX2022.sendersWay = []
        }
        if (!this.strategyTwo) {
          this.$refs["FZCX2022"].validateField(['NDCXMBMLLBCDY7Z','NDCXMBMLLBCD6X7Z','NDCXMBMLLBCD5X6Z','NDCXMBMLLBCXY5Z'])
          this.FZCX2022.NDCXMBMLLBCDY7Z = undefined
          this.FZCX2022.NDCXMBMLLBCD6X7Z = undefined
          this.FZCX2022.NDCXMBMLLBCD5X6Z = undefined
          this.FZCX2022.NDCXMBMLLBCXY5Z = undefined
        }
      })
    },
    refreshProp () {
      this.$nextTick(() => {
        if(this.GETFZCX){
          console.log(this.GETFZCX)
          this.FZCX2022 = Object.assign(this.FZCX2022,this.GETFZCX)
          // 折扣-售价损失补差≤5有值，则促销类型补差策略复选框选中
          this.FZCX2022.XY5Z && (this.strategyOne = true)
          // 促销补差-目标毛利率补差>7折有值，则整体促销补差策略复选框选中
          this.FZCX2022.NDCXMBMLLBCDY7Z && (this.strategyTwo = true)
        }
      })
    }
  },
  created(){
    this.refreshProp()
    let param = JSON.parse(sessionStorage.getItem('param'));
    this.source = param.source || "detail";
  },
  watch: {  
    FZCX2022:{
      handler:function(nowVal, oldVal){
        this.$emit('getFZCX', nowVal)
      },
      deep:true
    }
  },
  computed:{
    isLook(){
      return this.source=="detail";
    },
    isEdit(){
      return this.source=="edit";
    },
    isAdd(){
      return this.source=="add";
    },
  }
}
</script>
<style lang="scss" scoped>
.salesPromotion{
  padding-top: 10px;
  .classify{
    line-height: 30px;
  }
  .red{
    color: #f00;
  }
  .mod-block{
    border-bottom: 2px dashed #eee;
    position: relative;
    margin-bottom: 15px;
    &:last-child{
      border: 0;
      padding: 0;
    }
    .mask{
      position: absolute;
      width: 100%;
      top: 15px;
      bottom: 0;
      z-index: 999;
      background-color: rgba(245,247,250, 0.3);
    }
  }
  /deep/ {
    .el-popover__reference-wrapper{
      color: #606266;
    }
    .el-radio__label{
      line-height: 30px;
    }
    .el-button--mini.is-circle{
      padding: 2px;
    }
    .el-button.is-circle{
      border: none;
      &:hover{
        background: none;
      }
    }
    .el-form-item__label{
      // font-size: 12px;
      text-align: left;
    }
    .el-form-item {
      margin-bottom: 20px !important;
    }
  }
  .input-item{
    display: flex;
    justify-content: flex-end;
    max-width: 568px;
    .right-input{
      flex: 1;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/contractmanagement/purchasecontract/add/module/salesPromotion.vue